import * as React from 'react';

import { ModalFullscreen } from '@cian/ui-kit';

import { mockSummary } from '../AiSummaryModalDesktop/mockSummary';
import { Header } from './parts/Header';
import { MobileContent } from './parts/MobileContent';
import { MobileNavbar } from './parts/MobileNavbar';
import * as style from './styles.css';

export interface IAiSummaryMobileActions {
  newbuildingId: number;
  call?: React.ReactNode;
  chat?: React.ReactNode;
}

export interface IAiSummaryModalMobileProps {
  open: boolean;
  onClose: () => void;
  actions: IAiSummaryMobileActions[];
}

export const AiSummaryModalMobile = ({
  open,
  onClose,
  actions,
}: IAiSummaryModalMobileProps): React.JSX.Element | null => {
  const [activeNewbuildingId, setActiveNewbuildingId] = React.useState(mockSummary.summarization[0].id);
  const activeSummary = mockSummary.summarization.find(item => item.id === activeNewbuildingId);
  const activeActions = actions.find(item => item.newbuildingId === activeNewbuildingId);

  if (!activeSummary) {
    return null;
  }

  return (
    <ModalFullscreen onClose={onClose} open={open}>
      <div className={style['container']}>
        <div className={style['top-panel']}>
          <Header onClose={onClose} />
          <MobileNavbar
            activeNewbuildingId={activeNewbuildingId}
            items={mockSummary.summarization}
            onSelectNewbuilding={setActiveNewbuildingId}
          />
        </div>
        <div className={style['content']}>
          <MobileContent
            call={activeActions?.call}
            chat={activeActions?.chat}
            disclaimer={mockSummary.disclaimer}
            emptyState={mockSummary.emptyState}
            summary={activeSummary}
          />
        </div>
      </div>
    </ModalFullscreen>
  );
};
